<script>
    import { onMount } from 'svelte';
    import LyUser from '../layouts/users/LyUser.svelte';
    import LyGroup from '../layouts/users/LyGroup.svelte';
    import * as Icons from 'lucide-svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import LyContent from '../layouts/components/LyContent.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import LySection from '../layouts/components/LySection.svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import { UsersStore } from '../stores/UsersStore.svelte.js';
    import LyTableHeadCol from '../layouts/tables/LyTableHeadCol.svelte';
    import LyTableHead from '../layouts/tables/LyTableHead.svelte';
    import LyTable from '../layouts/tables/LyTable.svelte';
    import LyTableHeadRow from '../layouts/tables/LyTableHeadRow.svelte';
    import LyTableBody from '../layouts/tables/LyTableBody.svelte';
    import LyTableBodyRow from '../layouts/tables/LyTableBodyRow.svelte';
    import LyTableBodyCol from '../layouts/tables/LyTableBodyCol.svelte';
    import LyId from '../layouts/components/LyId.svelte';

    let mounting = $state(true);

    onMount(() => {
        UsersStore.reset();
        mounting = false;
    });
</script>

<LyContent wrapper={true} mb={true}>
    <LyHeader>
        <LyHeadline icon={Icons.Users}>Benutzerverwaltung</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>
            Eine Übersicht über alle <strong>Benutzer</strong> im System.
        </LyP>
    </LySection>
</LyContent>

{#if mounting && UsersStore.isLoading}
    <LyContent>
        <LyP><em>Benutzer werden geladen&hellip;</em></LyP>
    </LyContent>
{:else if UsersStore.users.length === 0}
    <LyContent>
        <LyP><em>Keine Benutzer gefunden&hellip;</em></LyP>
    </LyContent>
{:else}
    <LyTable>
        <LyTableHead>
            <LyTableHeadRow>
                <LyTableHeadCol>ID</LyTableHeadCol>
                <LyTableHeadCol>Benutzer</LyTableHeadCol>
                <LyTableHeadCol>
                    <div>Benutzername</div>
                    <div>Name</div>
                </LyTableHeadCol>
                <LyTableHeadCol>E-Mail</LyTableHeadCol>
                <LyTableHeadCol>Gruppen</LyTableHeadCol>
            </LyTableHeadRow>
        </LyTableHead>
        <LyTableBody>
            {#each UsersStore.users as user}
                <LyTableBodyRow>
                    <LyTableBodyCol>
                        <LyId show_id={user.userId} />
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        <LyUser user_id={user.userId} />
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        <p class="font-mono text-sm">{user.userName || '-'}</p>
                        <p>{user.firstName || '-'} <strong>{user.lastName || '-'}</strong></p>
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        {user.email || '-'}
                    </LyTableBodyCol>
                    <LyTableBodyCol>
                        {#each user.groups ?? [] as group}
                            <div>
                                <LyGroup {group} />
                            </div>
                        {/each}
                    </LyTableBodyCol>
                </LyTableBodyRow>
            {/each}
        </LyTableBody>
    </LyTable>
{/if}
